import Button from '@hellodarwin/core/lib/components/common/button';
import Typography from '@hellodarwin/core/lib/components/common/typography';
import GreenCheck from '@hellodarwin/icons/dist/icons/GreenCheck';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';
import {
  SubmitRfpModalActions,
  SubmitRfpSuccessActionsPrimary,
  SubmitRfpSuccessActions,
} from './styles';

interface SubmitRfpSuccessProps {
  handleClose: () => void;
}
const SubmitRfpSuccess = ({ handleClose }: SubmitRfpSuccessProps) => {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <SubmitRfpSuccessActions>
      <SubmitRfpModalActions>
        <GreenCheck size={70} color={theme.colors.green_1} />
        <SubmitRfpSuccessActionsPrimary>
          <Typography elementTheme="h5" bold fitContent>
            {t('rfp|submitRfpForm.successModal.title')}
          </Typography>
          <Typography elementTheme="body1" textAlign={'center'}>
            {t('rfp|submitRfpForm.successModal.text')}
          </Typography>
        </SubmitRfpSuccessActionsPrimary>
      </SubmitRfpModalActions>
      <Button
        onClick={handleClose}
        defaultStyle={theme.colors.primary}
        size="small"
      >
        Ok
      </Button>
    </SubmitRfpSuccessActions>
  );
};

export default SubmitRfpSuccess;
